import { createSelector } from 'reselect';
import { filter, flow, get, has, keyBy, groupBy, min, sumBy } from 'lodash/fp';

function getBonusBalance(
  singleChallengeId,
  pendingEntries,
  compatibleChallenges,
  bonuses,
  totalBalance
) {
  if (singleChallengeId) {
    return flow(
      filter(bonus => !bonus.challenge || bonus.challenge.id === singleChallengeId),
      sumBy('value')
    )(bonuses);
  }

  if (pendingEntries) {
    const groupedBonuses = groupBy('challenge.id', bonuses);
    const challenges = keyBy('id', compatibleChallenges);

    let total = 0;

    Object.entries(groupedBonuses).forEach(([challengeId, items]) => {
      const subtotal = sumBy('value', items);

      if (challengeId === 'undefined') {
        total += subtotal;
      } else if (has(challengeId, challenges)) {
        total += min([challenges[challengeId].cost * pendingEntries[challengeId], subtotal]);
      }
    });

    return total;
  }

  return totalBalance;
}

const bonusBalanceSelector = createSelector(
  get('challenge.id'),
  get('compatibleChallenges.pendingEntries'),
  get('compatibleChallenges.challenges'),
  get('user.currentUser.bonusPack.bonuses'),
  get('user.currentUser.bonusPack.totalBalance'),
  getBonusBalance
);

export default bonusBalanceSelector;
